<template>
    <b-card no-body>
        <b-tabs card>
            <b-tab title="Summary" active>
                <b-card-body :title="title">
                    <b-form @submit.stop.prevent="onSubmit">
                        <b-form-group
                            id="name-group"
                            label="Name*"
                            label-for="input-name"
                            label-cols="3"
                            label-class="font-weight-bold pt-0"
                        >
                            <b-form-input
                                type="text"
                                id="input-name"
                                v-model="model.name"
                                required
                                placeholder="Enter Name"
                                trim
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="description-group"
                            label="Description"
                            label-for="input-description"
                            label-cols="3"
                            label-class="font-weight-bold pt-0"
                        >
                            <b-form-input
                                type="text"
                                id="input-description"
                                v-model="model.description"
                                placeholder="Enter Description"
                                trim
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="reasons-group"
                            label="Reasons"
                            label-for="input-reasons"
                            label-cols="3"
                            label-class="font-weight-bold pt-0"
                        >
                            <b-form-input
                                type="text"
                                id="input-reasons"
                                v-model="model.reasons"
                                placeholder="Enter Reasons"
                                trim
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="enforced-group"
                            label="Mandatory:"
                            label-for="input-enforced"
                            label-cols="3"
                            label-class="font-weight-bold pt-0"
                        >
                            <b-form-checkbox
                                id="input-enforced"
                                name="input-enforced"
                                v-model="model.enforced"
                                :value="1"
                                :unchecked-value="0"
                            >
                            </b-form-checkbox>
                        </b-form-group>

                        <b-form-group
                            id="do_release-group"
                            label="Do Release:"
                            label-for="input-do_release"
                            label-cols="3"
                            label-class="font-weight-bold pt-0"
                        >
                            <b-form-checkbox
                                id="input-do_release"
                                name="input-do_release"
                                v-model="model.do_release"
                                :value="1"
                                :unchecked-value="0"
                            >
                            </b-form-checkbox>
                        </b-form-group>

                        <b-button-group size="sm">
                            <b-button
                                variant="secondary"
                                :disabled="loading ? true : false"
                                @click="cancel()"
                                >Cancel</b-button
                            >
                            <b-button
                                type="submit"
                                variant="primary"
                                :disabled="loading ? true : false"
                                >{{ submitLabel }}</b-button
                            >
                            <b-button
                                v-if="model.id"
                                @click="deleteCheckoffType()"
                                variant="warning"
                            >
                                Delete
                            </b-button>
                        </b-button-group>
                    </b-form>
                </b-card-body>
            </b-tab>
            <b-tab title="Roles" :disabled="!model.id">
                <CheckoffTypeRoles v-if="!!item.id" />
            </b-tab>
        </b-tabs>
    </b-card>
</template>
<script>
import CheckoffTypeRoles from './CheckoffTypeRoles.vue'
export default {
    name: 'view-item',
    components: { CheckoffTypeRoles },
    data() {
        return {
            loading: false,
            model: {
                id: 0,
                name: null,
                description: null,
                reasons: null,
                enforced: null,
                do_release: null,
            },
            updating: false,
            submitting: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        title() {
            return this.model.id ? 'Review Type' : 'Create Review Type'
        },

        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) this.model = this.item
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            const model = { ...this.model }
            console.log('model', model)
            const path = model.id
                ? 'checkoffTypes/update'
                : 'checkoffTypes/create'
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    model.enforced = model.enforced ? 1 : 0
                    model.do_release = model.do_release ? 1 : 0
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            const message = this.model.id
                                ? 'Updated'
                                : 'Created'
                            this.$emit('success', message, model.name)
                        })
                        .catch(error => {
                            const message = "Duplicate Entry"
                            this.$emit('danger',message,error.message)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },

        deleteCheckoffType() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'checkoffTypes/delete'

            // Generate and display confirmation prompt
            const title = 'Delete Review Type?'
            const message = `Are you sure you want to delete ${model.name}?`
            const errorMsg = 'Unable to delete Review Type!'

            this.$emit(
                'delete-item',
                message,
                title,
                model.id,
                () => {
                    this.$emit('success', 'Deleted', model.name)
                },
                path,
                errorMsg
            )
        },
    },
}
</script>
<style></style>
